import "./OurPrograms.module.css";
import Header from "@/reusable_sections/Header";
import ServicesLaCommunaut from "./sections/ServicesLaCommunaut";
import SoutenezNotreCause from "./sections/SoutenezNotreCause";
import Footer from "@/reusable_sections/Footer";
export default function OurProgramsPage() {
  return <div>
      <Header />
      <ServicesLaCommunaut />
      <SoutenezNotreCause />
      <Footer />
    </div>;
}